<template>
  <div>
    <div class="title"><div>筛选猩号空间数据统计</div></div>
    <div>
      <el-date-picker
        v-model="value"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
        @change="ceshi();"
      >
      </el-date-picker>
    </div>
    <el-table :data="data">
      <el-table-column label="人员" prop="name"> </el-table-column>
      <el-table-column label="删除点" prop="deletePoint" sortable>
      </el-table-column>
      <el-table-column label="取消一点" prop="cancelPoint" sortable>
      </el-table-column>
      <el-table-column label="新增点" prop="addPoint" sortable>
      </el-table-column>
      <el-table-column label="删除范围" prop="deleteboundary" sortable>
      </el-table-column>
      <el-table-column label="新增范围" prop="addboundary" sortable>
      </el-table-column>
      <el-table-column label="删除一类" prop="deletelei" sortable>
      </el-table-column>
      <el-table-column label="取消一类" prop="cancellei" sortable>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
//2.撤销一个点3.新增一个点，4.新增一个范围5.删除一个范围6.删除一类，7.取消一类
export default {
  data() {
    return {
      data: [],
      value: "",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()+24*3600*1000;
        }
      }
    };
  },
  mounted() {
    this.$axios.get(this.$url_prefix + "getfiniedList").then(res => {
      this.data = res.data.data;
      console.log(this.data);
    });
  },
  methods: {
    ceshi() {
      this.$axios
        .post(this.$url_prefix + "getfiniedList", {
            time: this.value
        })
        .then(res => {
          this.data = res.data.data;
        });
    }
  }
};
</script>

<style>
.title {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/page/finishTable.vue